export var AppLangCode;
(function (AppLangCode) {
    AppLangCode["EN"] = "en";
    AppLangCode["KA"] = "ka";
    AppLangCode["RU"] = "ru";
    AppLangCode["UA"] = "ua";
})(AppLangCode || (AppLangCode = {}));
//# sourceMappingURL=language.js.map